
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-3 -3 136 136","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_519_1972)"}},[_c('circle',{attrs:{"cx":"66","cy":"66","r":"66","fill":"#D2D5D9","stroke":"transparent","stroke-width":"8"}}),_c('path',{staticClass:"black-fill",attrs:{"d":"M81.536 62.986H42.54V47.556h38.997c2.278 0 3.862.397 4.657 1.09.795.694 1.287 1.98 1.287 3.858v5.541c0 1.98-.492 3.265-1.287 3.959-.795.693-2.379.99-4.657.99v-.007zm2.675-29.98H26V99h16.539V77.53h30.479L87.48 99H106L90.055 77.429c5.878-.871 8.518-2.673 10.695-5.642 2.177-2.97 3.269-7.716 3.269-14.051v-4.948c0-3.758-.398-6.727-1.092-9.002-.694-2.276-1.88-4.255-3.565-6.033-1.78-1.683-3.76-2.868-6.14-3.663-2.378-.693-5.35-1.09-9.01-1.09v.006z","fill":"#fff"}}),_c('path',{staticClass:"black-fill rutube-top-circle",attrs:{"d":"M198 0c0 36.45-29.549 66-66 66a65.919 65.919 0 01-21.186-3.474c.142-1.568.205-3.172.205-4.79v-4.948c0-4.202-.439-7.906-1.396-11.044-1.033-3.385-2.803-6.298-5.18-8.806l-.132-.14-.139-.131c-2.532-2.395-5.403-4.105-8.733-5.216l-.128-.043-.13-.038c-3.17-.924-6.83-1.37-10.97-1.37h-7v.006h-5.89C67.896 18.026 66 9.234 66 0c0-36.45 29.55-66 66-66 36.451 0 66 29.55 66 66z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_519_1972"}},[_c('rect',{attrs:{"width":"132","height":"132","rx":"66","fill":"#fff"}})])])])
          )
        }
      }
    